module.exports = __webpack_public_path__ + "static/media/promotion_under_30.1c6faf02.webp";